/**
 * Padrões do DS para as props de um wrapper do Prime: `props` vence, mas uma prop `undefined` da tela não apaga o padrão
 * (um spread simples copiaria o `undefined` por cima dele).
 */
export function withDefaults<D extends object, P extends object>(defaults: D, props: P): D & P {
  const defined = Object.fromEntries(
    Object.entries(props).filter(([, value]) => value !== undefined),
  );
  return { ...defaults, ...defined } as D & P;
}
